/* eslint-disable react/display-name */
import React from 'react';

const Wrapper: React.FC = React.memo(
  () => {
    return (
      <div>
        <p>Booking Engine Webcomponent</p>
      </div>
    );
  },
  () => true
);

const WebComponent = {
  tag: 'cb-example',
  element: Wrapper,
  attributes: {},
};

export default WebComponent;
